import { z } from 'zod';
import { requiredString } from '../helpers';
export const Cal_Dotcom_Get_Available_Slots_1_ConfigValidator = z.object({
    calConnection: requiredString('Cal.com Connection is required'),
    startTime: requiredString('Start time is required'),
    endTime: requiredString('End time is required'),
    timezone: z.string().optional()
});
//# sourceMappingURL=cal-dotcom-get-available-slots-1.js.map